import { IFormJBPHPContactChangeRequest } from 'legacy/lut/classes/models/partner360/IFormHPContacts'
import { AcknowledgmentAction } from 'legacy/lut/components/widgets/public/partner360/commitment/enums/AckonwledgmentAction'
import { CommitmentTypes } from 'legacy/lut/components/widgets/public/partner360/commitment/models'
import { requestAcknowledgement } from 'legacy/lut/features/partner360/commitment'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations'
import { Dropdown } from 'core-components/library/dropdown'
import { useStaticCrud } from 'core-components/types/helpers'
import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import { TRANSLATION_KEYS } from 'partner360/widgets/ramManagerAssignment/translations'

import { AssignmentCommitmentStatus } from '../../models'

import { values } from './config'

interface IAcknowledgementToggleProps {
  contact: IFormJBPHPContactChangeRequest
  commitmentStatus: AssignmentCommitmentStatus
  partnerId: string
  fYear: number
  programType: string
  commitmentItemEntryId: number | null
  role: string
}

export const AcknowledgementToggle = ({
  contact,
  commitmentStatus,
  programType,
  commitmentItemEntryId,
  fYear,
  role,
  partnerId,
}: IAcknowledgementToggleProps) => {
  const isEditMode = useSelector(selectPublishingMode)
  const dispatch = useAppDispatch()

  const source = useStaticCrud({
    data: values,
    keyField: 'key',
    displayField: 'value',
  })

  const onChange = useCallback(
    (value: string) => {
      const status = value as AssignmentCommitmentStatus

      const data = {
        partnerId,
        fYear,
        programType,
        entryId: commitmentItemEntryId,
      }
      if (!value) {
        return
      }
      if (value === AssignmentCommitmentStatus.None) {
        dispatch(
          requestAcknowledgement({
            ...data,
            actionData: {
              Action: AcknowledgmentAction.Remove,
              CommitmentType: CommitmentTypes.PBM,
            },
          })
        )
      } else {
        dispatch(
          requestAcknowledgement({
            ...data,
            actionData: {
              Action: commitmentItemEntryId
                ? AcknowledgmentAction.Change
                : AcknowledgmentAction.Add,
              CommitmentType: CommitmentTypes.PBM,
              Email: contact.Email,
              FirstName: contact.FirstName,
              LastName: contact.LastName,
              Role: role,
              IsOptional: status === AssignmentCommitmentStatus.Mandatory ? 0 : 1,
            },
          })
        )
      }
    },
    [
      commitmentItemEntryId,
      contact.Email,
      contact.FirstName,
      contact.LastName,
      dispatch,
      fYear,
      partnerId,
      programType,
      role,
    ]
  )

  if (!isEditMode) {
    if (commitmentStatus === AssignmentCommitmentStatus.Mandatory) {
      return <Translation text={TRANSLATION_KEYS.acknowledge.included} />
    }
    if (commitmentStatus === AssignmentCommitmentStatus.Optional) {
      return <Translation text={TRANSLATION_KEYS.acknowledge.optional} />
    }

    return <Translation text={TRANSLATION_KEYS.acknowledge.excluded} />
  }

  return (
    <Dropdown
      source={source}
      value={commitmentStatus}
      caption="value"
      onChange={onChange}
      label=""
    />
  )
}
